import $ from 'jquery';
import Backbone from 'backbone';
import AddToCart from '../../components/addToCart/addToCart';
import { register } from '../../core/bootstrapper';
import AddToWishlistView from '../../pages/pdp-new/addToWishlistView';
import WishlistButtonEvents from '../../tracking/pdp-new/pdpWishlistButtonEvents';
import Configuration from '../../tracking/pdp-new/Configuration';
import ProductClick from '../../tracking/pdp-new/ProductClick';
import * as config from '../../../home24/core/config';

register('article-new', function () {

    // reviews
    $.subscribe('save.PdpApp:review', function (event, data) {
        var submitReviewUrl = config.getBaseUrl() + '/article/saverating';

        $.post(submitReviewUrl, $.param(data), function (resp) {
            $.publish('saveFinished.PdpApp:review', { success: resp.success });
        });
    });

    // add to cart
    new AddToCart({
        pageType: 'pdp_product'
    });

    // model
    var pdpArticleModel = new Backbone.Model;

    // wishlist button
    new AddToWishlistView({
        el: $('#pdp-app-root'),
        model: pdpArticleModel
    });

    // tracking
    new WishlistButtonEvents({
        model: pdpArticleModel
    });

    new Configuration({
        model: pdpArticleModel
    });

    var productClickTracking = new ProductClick({
        model: pdpArticleModel
    });

    // set initial model data, used by ProductClick
    $.subscribe('loaded.PdpApp:article', function (event, data) {
        var options = {
            silent: true
        };

        pdpArticleModel.set({
            trackingData: data.trackingData
        }, options);

        productClickTracking.executeCookieCallbacks();
    });

    // will trigger model change, used by
    // AddToWishlistView
    // WishlistButtonEvents
    // and Configuration
    $.subscribe('changed.PdpApp:article', function (event, data) {

        var price = '';

        if (data.price && data.price.sellPrice) {
            price = data.price.sellPrice.single * 100;
        }

        pdpArticleModel.set({
            priceRaw: price,
            simpleSku: data.sku,
            trackingData: data.trackingData
        });
    });

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/pdp-new/pdpNewBootstrap.js
 **/